<template>
  <div class="dropdown">
    <button
      :id="id"
      type="button"
      aria-haspopup="true"
      :aria-expanded="open.toString()"
      @click="toggleDropdown"
      :disabled="dropdownDisabled"
    >
      <div class="text-ellipsis">{{ displaySelectedValue }}</div>
      <div class="icon" v-if="!open">
        <angle-down></angle-down>
      </div>
      <div class="icon" v-else>
        <angle-up></angle-up>
      </div>
    </button>
    <div class="dropdown-select" :aria-labelledby="id" v-if="open">
      <ul>
        <li v-for="(item, i) in dropdownValues" :key="i">
          <a href="#" @click.prevent="selectItem(i)" class="text-ellipsis">{{
            item.text
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AngleDown from "@/assets/caret-down-alt.svg";
import AngleUp from "@/assets/caret-up-alt.svg";
export default {
  name: "CertDropdown",
  props: {
    id: String,
    dropdownValues: Array,
    dropdownDefaultText: String,
    dropdownDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedValue: undefined,
      open: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.open = !this.open;
    },
    selectItem(i) {
      this.selectedValue = this.dropdownValues[i].text;
      this.open = false;
      this.$emit("change", this.dropdownValues[i]);
    },
    closeDropdown(e) {
      if (!this.$el.contains(e.target)) {
        this.open = false;
      }
    },
  },
  computed: {
    displaySelectedValue() {
      return this.selectedValue || this.dropdownDefaultText;
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdown);
  },
  components: {
    AngleDown,
    AngleUp,
  },
};
</script>

<style lang="scss" scoped>
$dropDownHeight: 35px;

.dropdown {
  position: relative;
  .dropdown-select {
    position: absolute;
    top: 0;
    left: 0;
    margin-top: $dropDownHeight;
    background-color: #fff;
    width: 100%;
    z-index: 1000;
    max-height: 150px;
    overflow-y: auto;
    ul {
      list-style: none;
      border: 1px solid $borderLightGray;

      li {
        border-bottom: 1px solid $borderLightGray;
      }

      li:last-child {
        border-bottom: 0;
      }

      a {
        padding: 0 16px;
        line-height: $dropDownHeight;
        color: $exDarkBlue;
        text-decoration: none;
        display: block;
        font-weight: normal;
        @include fontSize(14px);
      }

      a:hover,
      a:focus {
        color: $exBlue;
      }
    }
  }
}

button {
  height: $dropDownHeight;
  width: 100%;
  border-radius: $borderRadius;
  border: 1px solid $borderLightGray;
  color: $formLightGray;
  background-color: $bgLightGray;
  padding: 8px 24px 8px 16px;
  position: relative;
  text-align: left;
  @include fontSize(14px);
  cursor: pointer;

  .icon {
    position: absolute;
    right: 16px;
    top: 50%;
    margin-top: -6px;
    line-height: 14px;

    svg {
      width: 13px;
    }
  }
}

button:not(:disabled):focus,
button:not(:disabled):hover {
  border-color: $exBlue;
  color: $exBlue;
}
</style>
